import React, { useState, useEffect } from "react";
import HeroBg1 from "../../assets/home-hero1.webp";
import HeroBg2 from "../../assets/home-hero2.webp";
import HeroBg3 from "../../assets/home-hero3.webp";

import Button from "../common/Button";
import Toast from "../common/Toast";
import AIAssistantChatModal from "../common/AIAssistantChatModal";
import { useNavigate } from "react-router-dom";
import { AssistantIcon } from "../Icons";
import "./Hero.css";

const heroTexts = ["Shaping", "Improvement", "Innovators"];
const heroBackgrounds = [HeroBg1, HeroBg2, HeroBg3];

const Hero = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [fadeIn, setFadeIn] = useState(true);
  const [toast, setToast] = useState({ show: false, title: "", message: "" });
  const [isChatOpen, setIsChatOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      setFadeIn(false);
      const timeoutId = setTimeout(() => {
        setCurrentIndex(
          (previousIndex) => (previousIndex + 1) % heroTexts.length,
        );
        setFadeIn(true);
      }, 500);

      return () => clearTimeout(timeoutId);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="max-w-[1920px] mx-auto relative overflow-hidden">
      <img
        src={heroBackgrounds[currentIndex]}
        alt="hero"
        className="h-[240px] w-full object-cover sm:h-[320px] md:h-[420px] lg:h-auto lg:min-h-[520px]"
      />
      <div className="absolute inset-x-0 top-[18%] z-10 px-4 sm:top-[22%] sm:px-8 md:top-[24%] lg:top-[28%] xl:top-[30%]">
        <div className="ml-6 lg:ml-12 2xl:ml-20 w-full max-w-[320px] sm:max-w-[520px] md:max-w-[680px] lg:max-w-[900px] xl:max-w-[1100px]">
          <h1 className="text-white font-bold text-2xl leading-7 sm:text-4xl sm:leading-[48px] md:text-5xl md:leading-[60px] lg:text-6xl lg:leading-[72px] 2xl:text-[96px] 2xl:leading-[113px]">
            <span
              className={`transition-all duration-500 inline-block ${
                fadeIn
                  ? "animate-slideIn opacity-100"
                  : "animate-slideDown opacity-0"
              }`}
            >
              {heroTexts[currentIndex]}
            </span>{" "}
            <br /> Future Innovators
          </h1>
          <div className="mt-4 flex flex-col min-[520px]:flex-row gap-3 sm:mt-6 lg:mt-8">
            <Button
              btnClassName="rounded-full bg-[#FF6636] text-white font-bold py-1.5 px-4 text-sm sm:px-6 sm:py-2 sm:text-lg lg:px-8 lg:py-3 lg:text-xl 2xl:px-10 2xl:py-4 2xl:text-2xl"
              btnText={"Book A Free Demo"}
              onClick={() =>
                setToast({
                  show: true,
                  title: "Login Required",
                  message:
                    "Create an account or log in to schedule your free demo session.",
                })
              }
            />
            <Button
              btnClassName="rounded-full bg-white text-black font-bold py-1.5 px-[23px] min-[520px]:px-4 text-sm sm:px-6 sm:py-2 sm:text-lg lg:px-8 lg:py-3 lg:text-xl 2xl:px-10 2xl:py-4 2xl:text-2xl"
              btnText={"Explore Courses"}
              onClick={() => navigate("/courses")}
            />
          </div>
        </div>
        {toast.show && (
          <Toast
            title={toast.title}
            message={toast.message}
            onClose={() => setToast((t) => ({ ...t, show: false }))}
          />
        )}
        <div className="absolute right-3 z-10  sm:right-4  lg:right-10 bottom-0 2xl:right-[114px]">
          <button
            type="button"
            onClick={() => setIsChatOpen(true)}
            className="flex items-center justify-center gap-0 rounded-xl bg-[#FF6636] px-2.5 py-1 text-xs font-medium text-white transition-colors duration-200 min-[400px]:gap-4 min-[400px]:px-3 min-[400px]:py-1.5 min-[400px]:text-sm lg:rounded-2xl lg:px-4 lg:py-2.5"
          >
            <AssistantIcon />
            <span className="hidden min-[520px]:inline">AI Assistant</span>
          </button>
        </div>

        <AIAssistantChatModal
          isOpen={isChatOpen}
          onClose={() => setIsChatOpen(false)}
        />
      </div>
    </div>
  );
};

export default Hero;
